/**
 * 通知状态枚举
 *
 * 状态流转：
 * PENDING -> SENT -> DELIVERED
 *                  -> FAILED
 */
export enum NotificationStatus {
  /** 待发送 - 通知已创建但尚未发送 */
  PENDING = 'PENDING',
  /** 已发送 - 通知已发送到消息通道（微信模板消息/短信） */
  SENT = 'SENT',
  /** 已送达 - 通知已成功送达嘉宾 */
  DELIVERED = 'DELIVERED',
  /** 发送失败 - 发送失败 */
  FAILED = 'FAILED',
}

/** 所有状态值的数组 */
export const NotificationStatusValues: string[] = Object.values(NotificationStatus);

/** 状态中文标签映射 */
export const NotificationStatusLabels: Record<NotificationStatus, string> = {
  [NotificationStatus.PENDING]: '待发送',
  [NotificationStatus.SENT]: '已发送',
  [NotificationStatus.DELIVERED]: '已送达',
  [NotificationStatus.FAILED]: '发送失败',
};

/**
 * 通知状态流转规则
 *
 * PENDING -> SENT（发送成功）
 * PENDING -> FAILED（发送失败）
 * SENT -> DELIVERED（确认送达）
 * SENT -> FAILED（送达失败）
 * FAILED -> PENDING（重试）
 */
export const NotificationStatusTransitions: Record<NotificationStatus, NotificationStatus[]> = {
  [NotificationStatus.PENDING]: [NotificationStatus.SENT, NotificationStatus.FAILED],
  [NotificationStatus.SENT]: [NotificationStatus.DELIVERED, NotificationStatus.FAILED],
  [NotificationStatus.DELIVERED]: [],
  [NotificationStatus.FAILED]: [NotificationStatus.PENDING],
};
